import { createCallchainHttp } from './callchain-http.js'

let http = null

export function configureEntityLibraryHttp(options) {
  http = createCallchainHttp({ ...options, basePath: '/api/visual-game/admin' })
}

function client() {
  if (http === null) throw new Error('configureEntityLibraryHttp must be called before entity library API use')
  return http
}

export async function listEntities(query) {
  return client().get('/game-entities', { query, routeId: 'visualGame.entityLibrary.list' })
}

export async function createEntity(body) {
  return client().post('/game-entities', { body, routeId: 'visualGame.entityLibrary.create' })
}

export async function getEntity(id) {
  return client().get(`/game-entities/${encodeURIComponent(id)}`, { routeId: 'visualGame.entityLibrary.detail' })
}

export async function getHardFacts(id) {
  return client().get(`/game-entities/${encodeURIComponent(id)}/hard-facts`, { routeId: 'visualGame.entityLibrary.hardFacts.get' })
}

/** facts 是自由 JSON——世界观圣经文档出来前，字段没有固定 schema。 */
export async function updateHardFacts(id, facts) {
  return client().put(`/game-entities/${encodeURIComponent(id)}/hard-facts`, { body: { facts }, routeId: 'visualGame.entityLibrary.hardFacts.update' })
}

export async function listEntityAssets(id) {
  return client().get(`/game-entities/${encodeURIComponent(id)}/assets`, { routeId: 'visualGame.entityLibrary.assets.list' })
}

export async function upsertEntityAsset(id, body) {
  return client().put(`/game-entities/${encodeURIComponent(id)}/assets`, { body, routeId: 'visualGame.entityLibrary.assets.upsert' })
}

export async function withdrawEntityAsset(id, assetId) {
  return client().post(`/game-entities/${encodeURIComponent(id)}/assets/${encodeURIComponent(assetId)}/withdraw`, {
    body: {}, routeId: 'visualGame.entityLibrary.assets.withdraw',
  })
}

/** 起 deep-research agent——调用即入库，不是预览。agent 还在训练，线上现在会报错。 */
export async function runEntityDeepResearch(id) {
  return client().post(`/game-entities/${encodeURIComponent(id)}/deep-research`, { body: {}, routeId: 'visualGame.entityLibrary.deepResearch' })
}

export async function listEntityRelationships(id) {
  return client().get(`/game-entities/${encodeURIComponent(id)}/relationships`, { routeId: 'visualGame.entityLibrary.relationships.list' })
}

export async function upsertEntityRelationship(id, toEntityId, body) {
  return client().put(`/game-entities/${encodeURIComponent(id)}/relationships/${encodeURIComponent(toEntityId)}`, {
    body, routeId: 'visualGame.entityLibrary.relationships.upsert',
  })
}
